// FILE: Schedules.js
// NOTE: DN backend/slice is not yet available.
// CHANGE: DN slice import + DN listener are added back BUT COMMENTED OUT so project compiles now.
// CHANGE: When backend is ready, just uncomment DN parts and wire the API constant.

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { Button, Spinner, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { BiErrorCircle } from "react-icons/bi";
import { employee_dashboard_actions_helper } from "../../../actions/actions_helper";
import { RETRIEVE_GRN_SCHEDULER_LIST_BY_NAME_API } from "../../../api/api_data";
import {
  fail_retrieve_grn_scheduler_list,
  loading_retrieve_grn_scheduler_list,
  reset_retrieve_grn_scheduler_list,
  success_retrieve_grn_scheduler_list,
} from "../../../reducers/dashboard_reducers/warehouse/retrieve_grn_scheduler_list_Slice";

/*
  DN SLICE (UNCOMMENT WHEN FILE EXISTS)
  import {
    fail_retrieve_dn_scheduler_list,
    loading_retrieve_dn_scheduler_list,
    reset_retrieve_dn_scheduler_list,
    success_retrieve_dn_scheduler_list,
  } from "../../../reducers/dashboard_reducers/warehouse/retrieve_dn_scheduler_list_Slice";
*/

/*
  DN API (UNCOMMENT WHEN BACKEND EXISTS)
  import { RETRIEVE_DN_SCHEDULER_LIST_BY_NAME_API } from "../../../api/api_data";
*/

import {
  RETRIEVE_GRN_SCHEDULER_LIST_ACCESS_DENIED_MSG,
  RETRIEVE_GRN_SCHEDULER_LIST_ERR_MSG,
  RETRIEVE_GRN_SCHEDULER_LIST_SUCCESS_MSG,
} from "../../../constants/success_error_messages_consts";

/*
  DN MESSAGES (OPTIONAL: add these constants later)
  import {
    RETRIEVE_DN_SCHEDULER_LIST_ACCESS_DENIED_MSG,
    RETRIEVE_DN_SCHEDULER_LIST_ERR_MSG,
    RETRIEVE_DN_SCHEDULER_LIST_SUCCESS_MSG,
  } from "../../../constants/success_error_messages_consts";
*/

import { messageToast } from "../../../utils/Utils";
import * as app_consts from "../../../constants/react_app_consts";
import { findModuleAction, underscore_words } from "../../../utils/functionalUtils";
import ModalAdd from "../components/modal/modal_add/ModalAdd";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import AuthNoData from "../../components/page_messaging/AuthNoData";
import usePersistentState from "../../../Hooks/usePersistentState";

const initial_actions_data = {
  create_grn_schedule: false,
  // CHANGE: keep true for now so DN button shows even before permission constant exists.
  create_dn_schedule: true,
};

const grn_type = app_consts.GRN_SCHEDULER_LIST;
const dn_type = app_consts.DN_SCHEDULER_LIST;

const Schedules = () => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = usePersistentState("scheduler:activeTab", "grn");

  const [componentData, setComponentData] = useState(initial_actions_data);
  const [account_actions, setAccountActions] = useState([]);

  // =======================
  // GRN STATE
  // =======================
  const [grn_page_data, setGrnPageData] = useState([]);
  const [grn_loading, setGrnLoading] = useState(true);
  const [grn_error, setGrnError] = useState("");
  const [grn_add_modal, setGrnAddModal] = useState(false);
  const [grn_sm, setGrnSm] = useState(false);
  const [grn_searchTerm, setGrnSearchTerm] = usePersistentState("scheduler:grn_searchTerm", "");
  const [grn_currentPage, setGrnCurrentPage] = usePersistentState("scheduler:grn_currentPage", 1);

  // =======================
  // DN STATE (mirrors GRN)
  // =======================
  const [dn_page_data, setDnPageData] = useState([]);
  const [dn_loading, setDnLoading] = useState(false); // DN backend not implemented yet
  const [dn_error, setDnError] = useState("");
  const [dn_add_modal, setDnAddModal] = useState(false);
  const [dn_sm, setDnSm] = useState(false);
  const [dn_searchTerm, setDnSearchTerm] = usePersistentState("scheduler:dn_searchTerm", "");
  const [dn_currentPage, setDnCurrentPage] = usePersistentState("scheduler:dn_currentPage", 1);

  const [itemPerPage] = useState(10);
  const skipInitialGrnResetRef = useRef(true);
  const skipInitialDnResetRef = useRef(true);

  // =======================
  // GRN API CALL
  // =======================
  const retrieve_grn_schdeuler_list = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_grn_scheduler_list,
        success_retrieve_grn_scheduler_list,
        fail_retrieve_grn_scheduler_list,
        RETRIEVE_GRN_SCHEDULER_LIST_ERR_MSG,
        RETRIEVE_GRN_SCHEDULER_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_GRN_SCHEDULER_LIST_BY_NAME_API,
        null,
        RETRIEVE_GRN_SCHEDULER_LIST_ACCESS_DENIED_MSG
      )
    );

    if (localStorage.getItem("log_cred")) {
      setAccountActions(JSON.parse(localStorage.getItem("log_cred"))?.user_actions);
    }
  };

  // =======================
  // DN API CALL (BACKEND NOT READY YET)
  // =======================
  const retrieve_dn_scheduler_list = () => {
    // WHEN BACKEND IS READY: replace this block with your dispatch call (kept below commented)
    setDnError("");
    setDnLoading(false);
    setDnPageData([]);

    /*
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_dn_scheduler_list,
        success_retrieve_dn_scheduler_list,
        fail_retrieve_dn_scheduler_list,
        RETRIEVE_DN_SCHEDULER_LIST_ERR_MSG,
        RETRIEVE_DN_SCHEDULER_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_DN_SCHEDULER_LIST_BY_NAME_API,
        null,
        RETRIEVE_DN_SCHEDULER_LIST_ACCESS_DENIED_MSG
      )
    );
    */
  };

  // =======================
  // PERMISSIONS
  // =======================
  useEffect(() => {
    if (account_actions) {
      let actions_data = { ...initial_actions_data };

      account_actions?.map((module) => {
        if (module.module_name === app_consts.WAREHOUSE_MANAGEMENT) {
          if (findModuleAction(app_consts.CREATE_GRN_SCHEDULE, module)) {
            actions_data.create_grn_schedule = true;
          }
          // WHEN YOU ADD THIS ACTION CONSTANT:
          // if (findModuleAction(app_consts.CREATE_DN_SCHEDULE, module)) {
          //   actions_data.create_dn_schedule = true;
          // }
        }
        return null;
      });

      setComponentData(actions_data);
    }
  }, [account_actions]);

  // =======================
  // GRN LISTENER
  // =======================
  const retrieve_grn_scheduler_list_listener = useSelector(
    (state) => state.retrieve_grn_scheduler_list.retrieve_grn_scheduler_list
  );

  useEffect(() => {
    if (retrieve_grn_scheduler_list_listener.status !== app_consts.IDLE) {
      if (retrieve_grn_scheduler_list_listener.status === app_consts.LOADING) {
        setGrnError("");
        setGrnLoading(true);
      } else {
        if (retrieve_grn_scheduler_list_listener.status === app_consts.FAIL) {
          setGrnError(retrieve_grn_scheduler_list_listener.message || RETRIEVE_GRN_SCHEDULER_LIST_ERR_MSG);
          messageToast(
            retrieve_grn_scheduler_list_listener.message || RETRIEVE_GRN_SCHEDULER_LIST_ERR_MSG,
            app_consts.FAIL
          );
        } else if (retrieve_grn_scheduler_list_listener.status === app_consts.SUCCESS) {
          setGrnPageData(retrieve_grn_scheduler_list_listener.data || []);
        }
        setGrnLoading(false);
        dispatch(reset_retrieve_grn_scheduler_list());
      }
    }
  }, [retrieve_grn_scheduler_list_listener, dispatch]);

  // =======================
  // DN LISTENER TO UNCOMMENT WHEN DN SLICE EXISTS
  // =======================
  /*
  const retrieve_dn_scheduler_list_listener = useSelector(
    (state) => state.retrieve_dn_scheduler_list.retrieve_dn_scheduler_list
  );

  useEffect(() => {
    if (retrieve_dn_scheduler_list_listener.status !== app_consts.IDLE) {
      if (retrieve_dn_scheduler_list_listener.status === app_consts.LOADING) {
        setDnError("");
        setDnLoading(true);
      } else {
        if (retrieve_dn_scheduler_list_listener.status === app_consts.FAIL) {
          setDnError(retrieve_dn_scheduler_list_listener.message || "Failed to retrieve delivery note schedules.");
          messageToast(
            retrieve_dn_scheduler_list_listener.message || "Failed to retrieve delivery note schedules.",
            app_consts.FAIL
          );
        } else if (retrieve_dn_scheduler_list_listener.status === app_consts.SUCCESS) {
          setDnPageData(retrieve_dn_scheduler_list_listener.data || []);
          setDnCurrentPageData(retrieve_dn_scheduler_list_listener.data || []);
        }
        setDnLoading(false);
        dispatch(reset_retrieve_dn_scheduler_list());
      }
    }
  }, [retrieve_dn_scheduler_list_listener, dispatch]);
  */

  // =======================
  // INITIAL LOAD
  // =======================
  useEffect(() => {
    retrieve_grn_schdeuler_list();
    retrieve_dn_scheduler_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // =======================
  // TAB SWITCH
  // =======================
  const switchTab = (tabKey) => {
    if (activeTab !== tabKey) {
      setActiveTab(tabKey);
      setGrnSm(false);
      setDnSm(false);
    }
  };

  // =======================
  // REFRESH PER TAB
  // =======================
  const refreshList = () => {
    if (activeTab === "grn") retrieve_grn_schdeuler_list();
    if (activeTab === "dn") retrieve_dn_scheduler_list();
  };

  // =======================
  // LOCAL SEARCH FILTERS
  // =======================
  const grn_current_page_data = useMemo(() => {
    if (!grn_searchTerm) return grn_page_data || [];
    const lower = grn_searchTerm.toLowerCase();
    return (grn_page_data || []).filter((item) =>
      (item?.grn_schdeuler?.name || "").toLowerCase().includes(lower)
    );
  }, [grn_page_data, grn_searchTerm]);

  const dn_current_page_data = useMemo(() => {
    if (!dn_searchTerm) return dn_page_data || [];
    const lower = dn_searchTerm.toLowerCase();
    return (dn_page_data || []).filter((item) =>
      (item?.dn_scheduler?.name || "").toLowerCase().includes(lower)
    );
  }, [dn_page_data, dn_searchTerm]);

  useEffect(() => {
    if (skipInitialGrnResetRef.current) {
      skipInitialGrnResetRef.current = false;
      return;
    }
    setGrnCurrentPage(1);
  }, [grn_searchTerm, setGrnCurrentPage]);

  useEffect(() => {
    if (skipInitialDnResetRef.current) {
      skipInitialDnResetRef.current = false;
      return;
    }
    setDnCurrentPage(1);
  }, [dn_searchTerm, setDnCurrentPage]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(grn_current_page_data.length / itemPerPage));
    if (grn_currentPage > maxPage) {
      setGrnCurrentPage(maxPage);
    }
  }, [grn_currentPage, grn_current_page_data.length, itemPerPage, setGrnCurrentPage]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(dn_current_page_data.length / itemPerPage));
    if (dn_currentPage > maxPage) {
      setDnCurrentPage(maxPage);
    }
  }, [dn_currentPage, dn_current_page_data.length, itemPerPage, setDnCurrentPage]);

  // =======================
  // PAGINATION
  // =======================
  const grn_indexOfLastItem = grn_currentPage * itemPerPage;
  const grn_indexOfFirstItem = grn_indexOfLastItem - itemPerPage;
  const grn_currentItems = grn_current_page_data?.slice(grn_indexOfFirstItem, grn_indexOfLastItem);

  const dn_indexOfLastItem = dn_currentPage * itemPerPage;
  const dn_indexOfFirstItem = dn_indexOfLastItem - itemPerPage;
  const dn_currentItems = dn_current_page_data?.slice(dn_indexOfFirstItem, dn_indexOfLastItem);

  // =======================
  // RENDER: GRN TAB
  // =======================
  const renderGRNTab = () => {
    return (
      <>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Goods Received Scheduler List</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(grn_loading || grn_error) && `Goods Received Scheduled: ${grn_current_page_data?.length}`}</p>
              </BlockDes>
              {!(grn_loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      refreshList();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>

            {!(grn_loading || grn_error) && (
              <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    href="#more"
                    className="btn btn-icon btn-trigger toggle-expand me-n1"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setGrnSm(!grn_sm);
                    }}
                  >
                    <Icon name="more-v"></Icon>
                  </a>
                  <div className="toggle-expand-content" style={{ display: grn_sm ? "block" : "none" }}>
                    <ul className="nk-block-tools g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            id="grn-search"
                            value={grn_searchTerm}
                            onChange={(e) => setGrnSearchTerm(e.target.value)}
                            placeholder="Search for Scheduled Goods Received"
                          />
                        </div>
                      </li>

                      {componentData?.create_grn_schedule && (
                        <li className="nk-block-tools-opt">
                          <Button className="toggle btn-icon d-md-none" color="primary" onClick={() => setGrnAddModal(true)}>
                            <Icon name="plus"></Icon>
                          </Button>
                          <Button className="toggle d-none d-md-inline-flex" color="primary" onClick={() => setGrnAddModal(true)}>
                            <Icon name="plus"></Icon>
                            <span>Add GRN Schedule</span>
                          </Button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>

        {grn_loading ? (
          <div className="p-5 d-flex align-center justify-center">
            <Spinner />
          </div>
        ) : grn_error ? (
          <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
            <BiErrorCircle className="text-danger fs-3" />
            <p>{grn_error}</p>
          </div>
        ) : grn_page_data && grn_page_data?.length > 0 ? (
          <Block>
            <div className="nk-tb-list is-separate is-medium mb-3">
              <DataTableHead className="nk-tb-item">
                <DataTableRow>
                  <span className="sub-text">Name</span>
                </DataTableRow>
                <DataTableRow size="mb">
                  <span className="sub-text">Consignments</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Action</span>
                </DataTableRow>
              </DataTableHead>

              {grn_currentItems.length > 0
                ? grn_currentItems.map((item) => (
                    <DataTableItem key={item.id}>
                      <DataTableRow>
                        <Link to={`/dashboard/grn_schedule/${underscore_words(item?.grn_schdeuler?.name)}`}>
                          <div className="user-card">
                            <div className="user-info">
                              <span className="tb-lead">
                                {item?.grn_schdeuler?.name || "--"}
                                <span className="dot dot-success d-md-none ms-1"></span>
                              </span>
                            </div>
                          </div>
                        </Link>
                      </DataTableRow>
                      <DataTableRow>
                        <span>{item?.grn_schdeuler?.count || "--"}</span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                        <div className="tb-odr-btns d-none d-sm-inline">
                          <Link to={`/dashboard/grn_schedule/${underscore_words(item?.grn_schdeuler?.name)}`}>
                            <Button color="primary" size="sm" className="btn btn-dim">
                              View
                            </Button>
                          </Link>
                        </div>
                        <Button className="btn-pd-auto d-sm-none">
                          <Icon name="chevron-right"></Icon>
                        </Button>
                      </DataTableRow>
                    </DataTableItem>
                  ))
                : null}
            </div>

            {grn_currentItems?.length > 0 && (
              <div className="mt-3">
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={grn_current_page_data?.length}
                  paginate={(pageNumber) => setGrnCurrentPage(pageNumber)}
                  currentPage={grn_currentPage}
                />
              </div>
            )}
          </Block>
        ) : (
          <AuthNoData no_data_message={"No Goods Received Data Found."} />
        )}

        <ModalAdd
          openModal={grn_add_modal}
          setOpenModal={setGrnAddModal}
          modalTitle="Add GRN Schedule"
          modalDescription="Please Complete this form to Create a GRN Schedule"
          type={grn_type}
          succFunc={() => {
            setGrnAddModal(false);
            retrieve_grn_schdeuler_list();
          }}
          size="xl"
          fullscreen
        />
      </>
    );
  };

  // =======================
  // RENDER: DN TAB
  // =======================
  const renderDNTab = () => {
    return (
      <>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Delivery Note Scheduler List</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(dn_loading || dn_error) && `Delivery Note Scheduled: ${dn_current_page_data?.length}`}</p>
              </BlockDes>
              {!(dn_loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      refreshList();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>

            {!(dn_loading || dn_error) && (
              <BlockHeadContent>
                <div className="toggle-wrap nk-block-tools-toggle">
                  <a
                    href="#more"
                    className="btn btn-icon btn-trigger toggle-expand me-n1"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setDnSm(!dn_sm);
                    }}
                  >
                    <Icon name="more-v"></Icon>
                  </a>
                  <div className="toggle-expand-content" style={{ display: dn_sm ? "block" : "none" }}>
                    <ul className="nk-block-tools g-3">
                      <li>
                        <div className="form-control-wrap">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            id="dn-search"
                            value={dn_searchTerm}
                            onChange={(e) => setDnSearchTerm(e.target.value)}
                            placeholder="Search for Scheduled Delivery Notes"
                          />
                        </div>
                      </li>

                      {componentData?.create_dn_schedule && (
                        <li className="nk-block-tools-opt">
                          <Button className="toggle btn-icon d-md-none" color="primary" onClick={() => setDnAddModal(true)}>
                            <Icon name="plus"></Icon>
                          </Button>
                          <Button className="toggle d-none d-md-inline-flex" color="primary" onClick={() => setDnAddModal(true)}>
                            <Icon name="plus"></Icon>
                            <span>Add Delivery Note Schedule</span>
                          </Button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>

        {dn_loading ? (
          <div className="p-5 d-flex align-center justify-center">
            <Spinner />
          </div>
        ) : dn_error ? (
          <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
            <BiErrorCircle className="text-danger fs-3" />
            <p>{dn_error}</p>
          </div>
        ) : dn_page_data && dn_page_data?.length > 0 ? (
          <Block>
            <div className="nk-tb-list is-separate is-medium mb-3">
              <DataTableHead className="nk-tb-item">
                <DataTableRow>
                  <span className="sub-text">Name</span>
                </DataTableRow>
                <DataTableRow size="mb">
                  <span className="sub-text">Consignments</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Action</span>
                </DataTableRow>
              </DataTableHead>

              {dn_currentItems.length > 0
                ? dn_currentItems.map((item) => (
                    <DataTableItem key={item.id}>
                      <DataTableRow>
                        <Link to={`/dashboard/dn_schedule/${underscore_words(item?.dn_scheduler?.name)}`}>
                          <div className="user-card">
                            <div className="user-info">
                              <span className="tb-lead">
                                {item?.dn_scheduler?.name || "--"}
                                <span className="dot dot-success d-md-none ms-1"></span>
                              </span>
                            </div>
                          </div>
                        </Link>
                      </DataTableRow>
                      <DataTableRow>
                        <span>{item?.dn_scheduler?.count || "--"}</span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                        <div className="tb-odr-btns d-none d-sm-inline">
                          <Link to={`/dashboard/dn_schedule/${underscore_words(item?.dn_scheduler?.name)}`}>
                            <Button color="primary" size="sm" className="btn btn-dim">
                              View
                            </Button>
                          </Link>
                        </div>
                        <Button className="btn-pd-auto d-sm-none">
                          <Icon name="chevron-right"></Icon>
                        </Button>
                      </DataTableRow>
                    </DataTableItem>
                  ))
                : null}
            </div>

            {dn_currentItems?.length > 0 && (
              <div className="mt-3">
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={dn_current_page_data?.length}
                  paginate={(pageNumber) => setDnCurrentPage(pageNumber)}
                  currentPage={dn_currentPage}
                />
              </div>
            )}
          </Block>
        ) : (
          <AuthNoData no_data_message={"No Delivery Note Schedules Data Found."} />
        )}

        <ModalAdd
          openModal={dn_add_modal}
          setOpenModal={setDnAddModal}
          modalTitle="Add Delivery Note Schedule"
          modalDescription="Please Complete this form to Create a Delivery Note Schedule"
          type={dn_type}
          succFunc={() => {
            setDnAddModal(false);
            retrieve_dn_scheduler_list();
          }}
          size="xl"
          fullscreen
        />
      </>
    );
  };

  return (
    <>
      <Head title={"Schedules"} />
      <Content>
        <div className="mb-3">
          <Nav tabs>
            <NavItem>
              <NavLink active={activeTab === "grn"} onClick={() => switchTab("grn")} style={{ cursor: "pointer" }}>
                GRN Schedules
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={activeTab === "dn"} onClick={() => switchTab("dn")} style={{ cursor: "pointer" }}>
                Delivery Note Schedules
              </NavLink>
            </NavItem>
          </Nav>
        </div>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="grn">{renderGRNTab()}</TabPane>
          <TabPane tabId="dn">{renderDNTab()}</TabPane>
        </TabContent>
      </Content>
    </>
  );
};

export default Schedules;
